"use client"

import classNames from "classnames"
import styles from "../../styles/LandingPage/Patients.module.scss"
import SText from "../components/Text/SText"
import StyledText from "../typography/typography-component"
import Image from "next/image"
import skColors from "../../styles/skColors"
import { useTranslations } from "next-intl"

const Explanation = ({ forDoctors = false }: { forDoctors?: boolean }) => {
  const t = useTranslations("index")

  if (!forDoctors) {
    return (
      <div
        style={{
          backgroundColor: skColors.grey[50],
        }}
        className={classNames(styles.expContainer, styles.flwr)}
      >
        <div className={classNames(styles.expTitle)}>
          <StyledText variant={"h2"} color={skColors.turquoise[600]} className={styles.adaptiveTitleSize}>
            {t("howItWorks.title")}
          </StyledText>
        </div>

        <div className={classNames(styles.expText)}>
          <StyledText variant={"pRegular"} className={styles.pRegularFontSize}>
            {t("howItWorks.paragraph1")}
          </StyledText>
          <StyledText variant={"pRegular"} className={styles.pRegularFontSize}>
            {t("howItWorks.paragraph2")}
          </StyledText>
          <StyledText variant={"pRegular"} className={styles.pRegularFontSize}>
            {t("howItWorks.paragraph3")}
          </StyledText>
        </div>

        <Image
          className={styles.expImage}
          src={"/images/cutis.webp"}
          alt={t("howItWorksdoctors.title")}
          width={489}
          height={489}
          style={{
            maxWidth: "100%",
            height: "auto",
          }}
        />
      </div>
    )
  }

  return null
}

export const DoctorExplanation = () => {
  const t = useTranslations("index")

  return (
    <div className={classNames(styles.lighttherapyFlexDoctor, styles.spaceBetween, styles.flwr)}>
      <div className={classNames(styles.col, styles.marginRightBigScreen)}>
        <div className={classNames(styles.box, styles.doctorExplanationTitle)}>
          <StyledText variant={"h2"} color={skColors.turquoise[600]} className={styles.adaptiveTitleSize}>
            {t("howItWorksdoctors.title")}
          </StyledText>
        </div>
        <div className={classNames(styles.explanationBody, styles.doctorsExplanationBody)}>
          <SText variant={"body"} size={16} color={"green500"}>
            {t("howItWorksdoctors.doctor.paragraph1")}
          </SText>
          <br />
          <br />
          <SText variant={"body"} size={16} color={"green500"}>
            {t("howItWorksdoctors.doctor.paragraph2")}
          </SText>
          <br />
          <br />
          <SText variant={"body"} size={16} color={"green500"}>
            {t("howItWorksdoctors.doctor.paragraph3")}
          </SText>
        </div>
      </div>

      <Image
        className={styles.explanationImage}
        src={"/images/cutis.webp"}
        alt={t("howItWorksdoctors.title")}
        width={489}
        height={489}
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
    </div>
  )
}

export default Explanation
